import Vue from "vue"


// Filter to generate title to slug
Vue.filter('slug', function (value) {
    if (!value) return ''
    let slug = value.replace(/[^a-zA-Z0-9]+/g,'-');
    return slug.toLowerCase();
})

// Filter to generate title to slug
Vue.filter('name', function (value) {
    if (!value) return ''
    let slug = value.replace(/[^a-zA-Z0-9]+/g,' ');
    return slug.charAt(0).toUpperCase() + slug.substr(1);
})


// WEBPACK FOOTER //
// ./src/filters/index.js